import * as React from 'react'

// reducers
import { Reducer, KEYS } from './reducer'
import { initialState, StateProps } from './initial'

// types
import { PlayerConfigProps, WebrtcStatus, StreamStatus, CommandsListItem } from './types'

const actions = () => {

  // ** States
  const [state, dispatch]: [StateProps, any] = React.useReducer(Reducer, initialState)
  const [commandsList, setCommandsList] = React.useState<CommandsListItem[]>([])

  // ** Classes
  const cls = new class {

    get state() {
      return state
    }

    get commandsList() {
      return commandsList
    }

    dispatch(payload: unknown) {
      dispatch({
        type: KEYS.UPDATE,
        payload,
      })
    }

    get isStreamActive() {
      return state.streamStatus === 'play'
    }

    get isWebrtcError() {
      const errorExist = ['failed', 'disconnected', 'disconnectedRestart'].includes(state.webrtcStatus)
      return errorExist
    }

    setWebrtcStatus(status: WebrtcStatus, message: string | boolean = false) {
      this.dispatch({ webrtcStatus: status, webrtcMessage: message })
    }

    setStreamStatus(status: WebrtcStatus, message: string | boolean = false) {
      this.dispatch({ streamStatus: status, streamMessage: message })
    }

    setFreezeFrame(freezeFrame: boolean) {
      this.dispatch({ freezeFrame })
    }

    // Commands list history for debug
    addCommand(payload: CommandsListItem) {
      dispatch({
        type: KEYS.ADD_COMMAND,
        payload,
      })

      setCommandsList(c => ([payload, ...c].slice(0, 100)))
    }

    saveConfig(playerConfig: PlayerConfigProps) {
      this.dispatch({ playerConfig })
    }

  }

  return cls
}

export interface ActionProps {
  state: StateProps,
  commandsList: CommandsListItem[],
  isStreamActive: boolean
  isWebrtcError: boolean
  setWebrtcStatus: (status: WebrtcStatus, message?: string | boolean) => void
  setStreamStatus: (status: StreamStatus, message?: string | boolean) => void
  setFreezeFrame: (freezeFrame: boolean) => void
  addCommand: (payload: CommandsListItem) => void
  saveConfig: (config: PlayerConfigProps) => void
}

export default actions
